webpackJsonp([68],{

/***/ 2387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicHistoryFiles_vue__ = __webpack_require__(3437);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f60cbc42_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicHistoryFiles_vue__ = __webpack_require__(3977);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3975)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f60cbc42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicHistoryFiles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f60cbc42_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicHistoryFiles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/clinicHistory/ClinicHistoryFiles.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f60cbc42", Component.options)
  } else {
    hotAPI.reload("data-v-f60cbc42", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_sessionStorage__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__ = __webpack_require__(1248);




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    goToSection: function goToSection(path) {
      var needsPatientId = !this.$store.getters['session/userIsPatient'] && this.$route.query.patientId;
      var route = { path: '' + __WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__["d" /* BASE_PATH */] + (path !== __WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__["O" /* MENU_PATH */] ? '/' + path : ''), query: {} };
      if (needsPatientId) route.query.patientId = this.$route.query.patientId;
      if (this.$route.query.petId) route.query.petId = this.$route.query.petId;
      this.$router.push(route).catch(function () {});
    }
  },
  data: function data() {
    return {
      historyReadOnly: !!sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_0__constants_sessionStorage__["a" /* READ_ONLY_TOKEN_SESSION_STORAGE_KEY */])
    };
  }
});

/***/ }),

/***/ 2461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddButton_vue__ = __webpack_require__(2543);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38b0fcd7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddButton_vue__ = __webpack_require__(2592);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2590)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38b0fcd7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/buttons/AddButton.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-38b0fcd7", Component.options)
  } else {
    hotAPI.reload("data-v-38b0fcd7", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'add-button',
  props: {
    buttonText: {
      type: String,
      required: false,
      default: function _default() {
        return this.$t('add-btn');
      }
    },
    showTextOnMobile: Boolean
  },
  computed: {
    btnText: function btnText() {
      return this.$uiHelpers.isMobile && !this.showTextOnMobile ? '' : this.buttonText;
    }
  },
  data: function data() {
    return {
      hover: false
    };
  }
});

/***/ }),

/***/ 2590:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2591);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("1c10b383", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-38b0fcd7\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AddButton.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-38b0fcd7\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AddButton.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2591:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ 2592:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("icon-button", {
    attrs: {
      icon: "/static-appopensalud/img/icons/morillas-svg-icons/primary/add.svg",
      text: _vm.btnText
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38b0fcd7", esExports)
  }
}

/***/ }),

/***/ 2644:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_PaginatedTable__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repositories_FilesRepository__ = __webpack_require__(2659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_forms_BaseSelect__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_buttons_BaseButton__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_base_buttons_AddButton__ = __webpack_require__(2461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_base_ui_BaseCard_vue__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_colours__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_clinicHistory__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__base_BaseModal_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__base_BaseDialog_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_clinicHistory_mixin__ = __webpack_require__(2446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lang_es_clinic_history_json__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lang_es_clinic_history_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__lang_es_clinic_history_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lang_en_clinic_history_json__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lang_en_clinic_history_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__lang_en_clinic_history_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lang_pt_clinic_history_json__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lang_pt_clinic_history_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__lang_pt_clinic_history_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants_locales__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__constants_db_patientFiles__ = __webpack_require__(2715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers_date_helpers__ = __webpack_require__(182);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'history-files-section',
    components: {
        PaginatedTable: __WEBPACK_IMPORTED_MODULE_0__components_base_PaginatedTable__["a" /* default */],
        BaseSelect: __WEBPACK_IMPORTED_MODULE_3__components_base_forms_BaseSelect__["default"],
        BaseButton: __WEBPACK_IMPORTED_MODULE_4__components_base_buttons_BaseButton__["default"],
        AddButton: __WEBPACK_IMPORTED_MODULE_5__components_base_buttons_AddButton__["a" /* default */],
        BaseCard: __WEBPACK_IMPORTED_MODULE_6__components_base_ui_BaseCard_vue__["default"],
        BFormFile: __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue__["q" /* BFormFile */],
        BIconFileEarmarkText: __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue__["X" /* BIconFileEarmarkText */],
        BIconUpload: __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue__["_18" /* BIconUpload */],
        FormFilePlugin: __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue__["_53" /* FormFilePlugin */],
        BIconEye: __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue__["V" /* BIconEye */],
        BaseModal: __WEBPACK_IMPORTED_MODULE_10__base_BaseModal_vue__["a" /* default */],
        BaseDialog: __WEBPACK_IMPORTED_MODULE_11__base_BaseDialog_vue__["default"]
    },
    props: {
        patientId: {
            type: String,
            required: false,
            default: null
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_12__mixins_clinicHistory_mixin__["a" /* default */]],
    computed: {
        stacked: function stacked() {
            return window.innerWidth < 810;
        },
        clinicHistoryRepository: function clinicHistoryRepository() {
            return Object(__WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__["a" /* default */])();
        }
    },
    data: function data() {
        var _this2 = this;

        return {
            files: null,
            showUploadBox: false,
            lockDialogInfo: {
                id: null,
                show: false,
                locking: false
            },
            uploader: {
                file: null
            },
            uploaderOverwrite: {
                file: null
            },
            selectedCompleteFile: {
                id: null,
                idHisEnlaces: null
            },
            table: {
                fields: [{
                    label: this.$t('name-column'),
                    key: 'fileName'
                }, {
                    label: this.$t('file-type-column'),
                    key: 'category',
                    formatter: function formatter(value, key, item) {
                        return !value ? _this2.$t('undefined') : _this2.$i18nHelpers.normalize(value);
                    }
                }, {
                    label: this.$t('uploadedby-column'),
                    key: 'createdBy'
                }, {
                    label: this.$t('date-column'),
                    key: 'createdAt',
                    formatter: function formatter(value, key, item) {
                        return value ? Object(__WEBPACK_IMPORTED_MODULE_18__helpers_date_helpers__["j" /* getDDMMYYYY */])(new Date(value)) : '-';
                    },
                    sortable: true
                }, {
                    label: '',
                    key: 'actionsMobile',
                    class: 'table-actions'
                }, {
                    label: '',
                    key: 'viewLink',
                    hiddenStacked: true
                }, {
                    label: '',
                    key: 'complete',
                    hiddenStacked: true
                }, {
                    label: '',
                    key: 'preview',
                    hiddenStacked: true
                }, {
                    label: '',
                    key: 'lockStatus',
                    hiddenStacked: true
                }, {
                    label: '',
                    key: 'remove',
                    hiddenStacked: true
                }],
                filters: {
                    specialtyId: null
                }
            },
            loading: false,
            tagSelect: {
                options: [],
                value: null,
                loading: false,
                filter: null
            },
            showCompleteModal: false,
            showDocumentOrLinkSelector: false,
            documentOrLinkValue: null,
            showUploadLinkBox: false,
            documentOrLinkOptions: [{ text: this.$t('document.uploadFromThisDevice'), value: 0 }, { text: this.$t('document.insertLink'), value: 1 }],
            link: {
                name: null,
                url: null
            },
            RED_COLOUR: __WEBPACK_IMPORTED_MODULE_7__constants_colours__["k" /* RED_COLOUR */],
            PRESCRIPTION_TYPE: __WEBPACK_IMPORTED_MODULE_17__constants_db_patientFiles__["a" /* PRESCRIPTION_TYPE */],
            REPORT_TYPE: __WEBPACK_IMPORTED_MODULE_17__constants_db_patientFiles__["b" /* REPORT_TYPE */]
        };
    },

    methods: {
        load: function load() {
            var _this3 = this;

            this.loading = true;
            this.clinicHistoryRepository.getHistoryFiles().then(function (response) {
                _this3.files = response.data.data;
                _this3.loading = false;
            });
            if (this.tagSelect.options.length === 0) {
                __WEBPACK_IMPORTED_MODULE_2__repositories_FilesRepository__["a" /* default */].getFilesTags().then(function (response) {
                    var tags = response.data.filter(function (item) {
                        return item.id !== 13;
                    });
                    tags.push({ id: -1, name: { es: __WEBPACK_IMPORTED_MODULE_13__lang_es_clinic_history_json__["reportOrPrescripcion"], en: __WEBPACK_IMPORTED_MODULE_14__lang_en_clinic_history_json__["reportOrPrescripcion"], pt: __WEBPACK_IMPORTED_MODULE_15__lang_pt_clinic_history_json__["reportOrPrescripcion"] } });
                    tags.push({ id: -2, name: { es: __WEBPACK_IMPORTED_MODULE_13__lang_es_clinic_history_json__["dataopensalud"], en: __WEBPACK_IMPORTED_MODULE_14__lang_en_clinic_history_json__["dataopensalud"], pt: __WEBPACK_IMPORTED_MODULE_15__lang_pt_clinic_history_json__["dataopensalud"] } });
                    tags.sort(function (a, b) {
                        return _this3.$i18n.locale === __WEBPACK_IMPORTED_MODULE_16__constants_locales__["a" /* EN_LOCALE */] ? a.name.en > b.name.en : _this3.$i18n.locale === __WEBPACK_IMPORTED_MODULE_16__constants_locales__["d" /* PT_LOCALE */] ? a.name.pt > b.name.pt : a.name.es > b.name.es;
                    });
                    _this3.tagSelect.options = tags;
                });
            }
        },
        loadApps: function loadApps() {
            var _this4 = this;

            this.clinicHistoryRepository.getApps().then(function (response) {
                _this4.files = response.data.data;
                _this4.loading = false;
            });
            if (this.tagSelect.options.length === 0) {
                __WEBPACK_IMPORTED_MODULE_2__repositories_FilesRepository__["a" /* default */].getFilesTags(true).then(function (response) {
                    _this4.tagSelect.options = response.data;
                });
            }
        },
        fileLocked: function fileLocked(data) {
            return data && data.item && data.item.locked && !this.$store.getters['session/userIsPatient'];
        },
        showLockedMessage: function showLockedMessage() {
            this.$store.dispatch('showInfoAlert', this.$t('fileLockedByPatient'));
        },
        showCompleteLink: function showCompleteLink(data) {
            return data.idHisEnlaces ? Object(__WEBPACK_IMPORTED_MODULE_8__constants_clinicHistory__["_9" /* isDocumentOrLinkPendingComplete */])(data.categoryId) : Object(__WEBPACK_IMPORTED_MODULE_8__constants_clinicHistory__["_7" /* isDocumentOrLink */])(data.categoryId);
        },
        showCompletedTitle: function showCompletedTitle(data) {
            return data.idHisEnlaces && Object(__WEBPACK_IMPORTED_MODULE_8__constants_clinicHistory__["_8" /* isDocumentOrLinkCompleted */])(data.categoryId);
        },
        getFiles: function getFiles(fileId) {
            var _this5 = this;

            var windowReference = window.open();
            this.clinicHistoryRepository.getFiles(fileId).then(function (response) {
                windowReference.location = response.data;
                _this5.$store.dispatch('notifications/updateSummary');
            });
        },
        documentOrLinkSelected: function documentOrLinkSelected() {
            if (this.documentOrLinkValue === 0) {
                this.showUploadLinkBox = false;
                this.showUploadBox = true;
            } else if (this.documentOrLinkValue === 1) {
                this.showUploadBox = false;
                this.showUploadLinkBox = true;
            }
        },
        tagSelected: function tagSelected() {
            if (this.tagSelect.value) {
                this.documentOrLinkValue = null;
                this.showUploadLinkBox = false;
                if (this.tagSelect.value === __WEBPACK_IMPORTED_MODULE_8__constants_clinicHistory__["U" /* RECOMMENDED_APPLICATIONS */] || this.tagSelect.value === __WEBPACK_IMPORTED_MODULE_8__constants_clinicHistory__["_0" /* USEFUL_LINK */]) {
                    this.showUploadLinkBox = true;
                    this.showUploadBox = false;
                } else if (Object(__WEBPACK_IMPORTED_MODULE_8__constants_clinicHistory__["_7" /* isDocumentOrLink */])(this.tagSelect.value) && !this.documentOrLinkValue) {
                    this.showUploadBox = false;
                    this.showDocumentOrLinkSelector = true;
                } else {
                    this.showUploadBox = true;
                    this.showDocumentOrLinkSelector = false;
                }
            } else {
                this.tagSelect.value = null;
                this.link.name = null;
                this.link.url = null;
                this.documentOrLinkValue = null;
                this.showUploadBox = false;
                this.showUploadLinkBox = false;
                this.showDocumentOrLinkSelector = false;
            }
        },
        filterTableCategories: function filterTableCategories(data, filter) {
            return data.categoryId === parseInt(filter);
        },
        saveLink: function saveLink() {
            var _this6 = this;

            if (!this.link.name) {
                this.$store.dispatch('showInfoAlert', this.$t('link.nameError'));
            } else if (!this.link.url || !this.$validators.validateUrl(this.link.url)) {
                this.$store.dispatch('showInfoAlert', this.$t('link.linkError'));
            } else {
                var data = { fileCategory: this.tagSelect.value, link: this.link };
                this.clinicHistoryRepository.saveApps(data).then(function (response) {
                    _this6.load();
                    _this6.resetFormFile();
                });
            }
        },
        uploadFile: function uploadFile(file) {
            if (!file) return;
            var _this = this;
            this.clinicHistoryRepository.uploadFileToClinicHistory(file, this.tagSelect.value, this).then(function (response) {
                _this.load();
                _this.resetFormFile();
            });
        },
        resetFormFile: function resetFormFile() {
            this.tagSelect.value = null;
            this.uploader.file = null;
            this.uploaderOverwrite.file = null;
            this.link.name = null;
            this.link.url = null;
            this.documentOrLinkValue = null;
            this.showUploadBox = false;
            this.showUploadLinkBox = false;
            this.showDocumentOrLinkSelector = false;
            this.selectedCompleteFile.id = null;
            this.selectedCompleteFile.idHisEnlaces = null;
            this.showCompleteModal = false;
        },
        accessLink: function accessLink(url, fileId) {
            __WEBPACK_IMPORTED_MODULE_2__repositories_FilesRepository__["a" /* default */].markLinkAsReaded(fileId);
            window.open(url.indexOf('http') > -1 ? url : 'http://' + url, '_blank');
        },
        resetCompleteModal: function resetCompleteModal() {
            this.showCompleteModal = false;
            this.uploaderOverwrite.file = null;
            this.resetFormFile();
        },
        completeAction: function completeAction(data) {
            this.showCompleteModal = true;
            this.selectedCompleteFile.id = data.id;
            this.selectedCompleteFile.idHisEnlaces = data.idHisEnlaces;
        },
        completeFile: function completeFile() {
            var _this7 = this;

            if (this.selectedCompleteFile.idHisEnlaces) {
                this.clinicHistoryRepository.markFileAsCompleted({ id: this.selectedCompleteFile.idHisEnlaces }).then(function (response) {
                    _this7.load();
                    _this7.resetFormFile();
                });
            } else {
                if (!this.uploaderOverwrite.file) {
                    this.$store.dispatch('showInfoAlert', this.$t('file.select'));
                    return;
                }
                this.clinicHistoryRepository.overwriteFileClinicHistory(this.uploaderOverwrite.file, this.selectedCompleteFile.id, this).then(function (response) {
                    _this7.load();
                    _this7.resetFormFile();
                    _this7.$store.dispatch('showSuccessAlert', _this7.$t('changesPerformedCorrectly'));
                });
            }
        },
        modifyFileLocking: function modifyFileLocking(unlock, data) {
            this.lockDialogInfo.locking = !unlock;
            this.lockDialogInfo.show = true;
            this.lockDialogInfo.id = data.idHisEnlaces || data.id;
        },
        lockFile: function lockFile() {
            var _this8 = this;

            this.clinicHistoryRepository.lockFile(this.lockDialogInfo.id).then(function (response) {
                _this8.lockChangeCompleted();
            });
        },
        unlockFile: function unlockFile() {
            var _this9 = this;

            this.clinicHistoryRepository.unlockFile(this.lockDialogInfo.id).then(function (response) {
                _this9.lockChangeCompleted();
            });
        },
        lockChangeCompleted: function lockChangeCompleted() {
            var _this10 = this;

            var file = this.files.find(function (f) {
                return f.id === _this10.lockDialogInfo.id || f.idHisEnlaces === _this10.lockDialogInfo.id;
            });
            file.locked = !file.locked;
            this.lockDialogInfo.show = false;
            this.lockDialogInfo.id = null;
        },
        remove: function remove(data) {
            var _this11 = this;

            if (data.idHisEnlaces) {
                this.clinicHistoryRepository.deleteApps(data.idHisEnlaces).then(function (response) {
                    if (response.data.data) {
                        _this11.files = _this11.files.filter(function (item) {
                            return item.idHisEnlaces !== data.idHisEnlaces;
                        });
                    }
                });
            } else {
                this.clinicHistoryRepository.deleteHistoryFile(data.id).then(function (response) {
                    if (response.data.data) {
                        _this11.files = _this11.files.filter(function (item) {
                            return item.id !== data.id;
                        });
                    }
                });
            }
        }
    },
    created: function created() {
        this.load();
    }
});

/***/ }),

/***/ 2659:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(282);



var client = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;

/* harmony default export */ __webpack_exports__["a"] = ({
  getFiles: function getFiles() {
    var fileId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return client.get(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* path */])('files', fileId));
  },
  getFilesTags: function getFilesTags() {
    var isApp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return client.get('fileTags', { params: { isApp: isApp } });
  },
  getImage: function getImage(fileId) {
    return client.get('files/downloadImage', { params: { id: fileId } });
  },
  markLinkAsReaded: function markLinkAsReaded(linkId) {
    return client.get('files/markLinkAsReaded', { params: { linkId: linkId } });
  }
});

/***/ }),

/***/ 2712:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryFilesSection_vue__ = __webpack_require__(2644);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a83df30_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryFilesSection_vue__ = __webpack_require__(2716);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2713)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a83df30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryFilesSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a83df30_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryFilesSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/shared/HistoryFilesSection.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1a83df30", Component.options)
  } else {
    hotAPI.reload("data-v-1a83df30", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2713:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2714);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("0557bbe4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1a83df30\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryFilesSection.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1a83df30\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryFilesSection.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2714:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-1a83df30]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-1a83df30],.slide-down-leave-active[data-v-1a83df30]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-1a83df30],.slide-down-leave-to[data-v-1a83df30]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-1a83df30],.slide-fade-left-leave-active[data-v-1a83df30]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-1a83df30],.slide-fade-left-leave-to[data-v-1a83df30]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-1a83df30]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-1a83df30],.fade-leave-to[data-v-1a83df30]{opacity:0\n}\n.completed-title[data-v-1a83df30]{color:#6AEF89\n}\n.icon-unlocked[data-v-1a83df30]{cursor:pointer;color:#6AEF89\n}\n.icon-locked[data-v-1a83df30]{cursor:pointer;color:#FF7061\n}\n.table-href[data-v-1a83df30]{cursor:pointer;color:#3238C4\n}\n.table-href[data-v-1a83df30]:hover{text-decoration:underline\n}\n.blue[data-v-1a83df30]{color:#3238C4\n}\n.margin-bottom-reduced[data-v-1a83df30]{margin-bottom:0.5rem\n}\n.stacked-item[data-v-1a83df30]{display:inline-block;margin-right:1rem\n}\n", ""]);

// exports


/***/ }),

/***/ 2715:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PRESCRIPTION_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REPORT_TYPE; });
var PRESCRIPTION_TYPE = 1;
var REPORT_TYPE = 2;

/***/ }),

/***/ 2716:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.files
        ? _c(
            "base-card",
            {
              attrs: {
                overflowVisible: "",
                title: _vm.$t("documentsAndInformation"),
                hideButtons: _vm.historyReadOnly
              }
            },
            [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c(
                    "div",
                    { staticClass: "col-lg-7 col-12 p-1" },
                    [
                      _c("base-select", {
                        attrs: {
                          searchable: "",
                          loading: _vm.tagSelect.loading,
                          options: _vm.tagSelect.options,
                          label: _vm.$i18nHelpers.normalizeProp("name"),
                          valueProp: "id",
                          placeholder: _vm.$t("addfile-ph"),
                          clearable: ""
                        },
                        on: { change: _vm.tagSelected },
                        model: {
                          value: _vm.tagSelect.value,
                          callback: function($$v) {
                            _vm.$set(_vm.tagSelect, "value", $$v)
                          },
                          expression: "tagSelect.value"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showDocumentOrLinkSelector
                    ? _c(
                        "div",
                        { staticClass: "col-lg-7 col-12 p-1" },
                        [
                          _c("base-radio-group", {
                            attrs: { options: _vm.documentOrLinkOptions },
                            on: { change: _vm.documentOrLinkSelected },
                            model: {
                              value: _vm.documentOrLinkValue,
                              callback: function($$v) {
                                _vm.documentOrLinkValue = $$v
                              },
                              expression: "documentOrLinkValue"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showUploadLinkBox
                    ? _c("div", { staticClass: "col-12 p-1" }, [
                        _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _c("base-input", {
                              staticClass:
                                "col-12 col-md-5 pr-md-2 margin-bottom-reduced",
                              attrs: {
                                zeroMarginBottom: "",
                                placeholder: _vm.$t("name")
                              },
                              model: {
                                value: _vm.link.name,
                                callback: function($$v) {
                                  _vm.$set(_vm.link, "name", $$v)
                                },
                                expression: "link.name"
                              }
                            }),
                            _vm._v(" "),
                            _c("base-input", {
                              staticClass:
                                "col-12 col-md-5 pr-md-2 margin-bottom-reduced",
                              attrs: {
                                zeroMarginBottom: "",
                                placeholder: _vm.$t("document.url")
                              },
                              model: {
                                value: _vm.link.url,
                                callback: function($$v) {
                                  _vm.$set(_vm.link, "url", $$v)
                                },
                                expression: "link.url"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-2" },
                              [
                                _c(
                                  "base-button",
                                  { on: { click: _vm.saveLink } },
                                  [_vm._v(_vm._s(_vm.$t("save-btn")))]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showUploadBox
                    ? _c("b-form-file", {
                        staticClass: "col-lg-7 col-12 mt-2",
                        attrs: {
                          placeholder: _vm.$t("select-or-drag-drop-file"),
                          "drop-placeholder": _vm.$t("drag-drop-file"),
                          "browse-text": _vm.$t("browse")
                        },
                        on: { input: _vm.uploadFile },
                        model: {
                          value: _vm.uploader.file,
                          callback: function($$v) {
                            _vm.$set(_vm.uploader, "file", $$v)
                          },
                          expression: "uploader.file"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-lg-7 col-12 p-1 mb-4" },
                [
                  _c("base-select", {
                    attrs: {
                      loading: _vm.tagSelect.loading,
                      options: _vm.tagSelect.options,
                      label: _vm.$i18nHelpers.normalizeProp("name"),
                      valueProp: "id",
                      placeholder: _vm.$t("filterByType"),
                      clearable: ""
                    },
                    model: {
                      value: _vm.tagSelect.filter,
                      callback: function($$v) {
                        _vm.$set(_vm.tagSelect, "filter", $$v)
                      },
                      expression: "tagSelect.filter"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("paginated-table", {
                attrs: {
                  fields: _vm.table.fields,
                  items: _vm.files,
                  "empty-text": _vm.$t("nofiles"),
                  filter: _vm.tagSelect.filter
                    ? "" + _vm.tagSelect.filter
                    : null,
                  filterFn: _vm.filterTableCategories,
                  stacked: _vm.stacked
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "cell(viewLink)",
                      fn: function(data) {
                        return [
                          data.item.link && !_vm.fileLocked(data)
                            ? _c(
                                "span",
                                {
                                  staticClass: "table-href",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.accessLink(
                                        data.item.link,
                                        data.item.idHisEnlaces
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("watch")))]
                              )
                            : _vm._e()
                        ]
                      }
                    },
                    !_vm.historyReadOnly
                      ? {
                          key: "cell(complete)",
                          fn: function(data) {
                            return [
                              _vm.showCompleteLink(data.item)
                                ? _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.completeAction(data.item)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("complete")))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showCompletedTitle(data.item) &&
                              !_vm.fileLocked(data)
                                ? _c("span", {
                                    staticClass: "completed-title",
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t("completedHistory")
                                      )
                                    }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      : null,
                    !_vm.historyReadOnly
                      ? {
                          key: "cell(preview)",
                          fn: function(data) {
                            return [
                              !data.item.idHisEnlaces &&
                              !_vm.fileLocked(data) &&
                              !data.item.readOnly
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "table-href",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.getFiles(data.item.fileId)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("download-btn")))]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      : null,
                    !_vm.historyReadOnly
                      ? {
                          key: "cell(lockStatus)",
                          fn: function(data) {
                            return [
                              _vm.$store.getters["session/userIsPatient"] &&
                              data.item.locked
                                ? _c("b-icon-lock-fill", {
                                    staticClass: "icon-locked",
                                    on: {
                                      click: function($event) {
                                        return _vm.modifyFileLocking(
                                          true,
                                          data.item
                                        )
                                      }
                                    }
                                  })
                                : _vm.$store.getters["session/userIsPatient"] &&
                                  !data.item.locked
                                ? _c("b-icon-unlock-fill", {
                                    staticClass: "icon-unlocked",
                                    on: {
                                      click: function($event) {
                                        return _vm.modifyFileLocking(
                                          false,
                                          data.item
                                        )
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.$store.getters["session/userIsPatient"] &&
                              _vm.fileLocked(data)
                                ? _c("b-icon-lock-fill", {
                                    staticClass: "icon-locked",
                                    on: { click: _vm.showLockedMessage }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      : null,
                    !_vm.historyReadOnly
                      ? {
                          key: "cell(remove)",
                          fn: function(data) {
                            return [
                              !_vm.fileLocked(data) &&
                              data.item.fileType != _vm.PRESCRIPTION_TYPE &&
                              data.item.fileType != _vm.REPORT_TYPE
                                ? _c("base-icon", {
                                    staticClass: "clickable",
                                    attrs: {
                                      src:
                                        "/static-appopensalud/img/icons/morillas-svg-icons/primary/remove.svg",
                                      color: _vm.RED_COLOUR
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.remove(data.item)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      : null,
                    !_vm.historyReadOnly
                      ? {
                          key: "cell(actionsMobile)",
                          fn: function(data) {
                            return [
                              _vm.fileLocked(data)
                                ? _c("div", [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("fileLockedByPatient")
                                        )
                                      }
                                    })
                                  ])
                                : _c("div", [
                                    data.item.link
                                      ? _c(
                                          "div",
                                          { staticClass: "stacked-item" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "table-href",
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.accessLink(
                                                      data.item.link,
                                                      data.item.idHisEnlaces
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("b-icon-eye", {
                                                  staticClass: "blue"
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.showCompleteLink(data.item) ||
                                    _vm.showCompletedTitle(data.item)
                                      ? _c(
                                          "div",
                                          { staticClass: "stacked-item" },
                                          [
                                            _vm.showCompleteLink(data.item)
                                              ? _c(
                                                  "a",
                                                  {
                                                    attrs: { href: "#" },
                                                    on: {
                                                      click: function($event) {
                                                        $event.preventDefault()
                                                        return _vm.completeAction(
                                                          data.item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("b-icon-pencil", {
                                                      staticClass: "blue"
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.showCompletedTitle(data.item)
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "completed-title"
                                                  },
                                                  [
                                                    _c("b-icon-check", {
                                                      staticClass: "blue"
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !data.item.idHisEnlaces &&
                                    !data.item.readOnly
                                      ? _c(
                                          "div",
                                          { staticClass: "stacked-item" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "table-href",
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.getFiles(
                                                      data.item.fileId
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("b-icon-download", {
                                                  staticClass: "blue"
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.$store.getters["session/userIsPatient"]
                                      ? _c(
                                          "div",
                                          { staticClass: "stacked-item" },
                                          [
                                            data.item.locked
                                              ? _c(
                                                  "span",
                                                  [
                                                    _c("b-icon-lock-fill", {
                                                      staticClass:
                                                        "icon-locked",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.modifyFileLocking(
                                                            true,
                                                            data.item
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : !data.item.locked
                                              ? _c(
                                                  "span",
                                                  [
                                                    _c("b-icon-unlock-fill", {
                                                      staticClass:
                                                        "icon-unlocked",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.modifyFileLocking(
                                                            false,
                                                            data.item
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    data.item.fileType !=
                                      _vm.PRESCRIPTION_TYPE &&
                                    data.item.fileType != _vm.REPORT_TYPE
                                      ? _c(
                                          "div",
                                          { staticClass: "stacked-item" },
                                          [
                                            _c("base-icon", {
                                              staticClass: "clickable",
                                              attrs: {
                                                src:
                                                  "/static-appopensalud/img/icons/morillas-svg-icons/primary/remove.svg",
                                                color: _vm.RED_COLOUR
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.remove(data.item)
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("hr")
                                  ])
                            ]
                          }
                        }
                      : null
                  ],
                  null,
                  true
                )
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "base-modal",
        {
          on: { hidden: _vm.resetCompleteModal },
          model: {
            value: _vm.showCompleteModal,
            callback: function($$v) {
              _vm.showCompleteModal = $$v
            },
            expression: "showCompleteModal"
          }
        },
        [
          _c("div", { staticClass: "text-center" }, [
            _vm.selectedCompleteFile.idHisEnlaces
              ? _c("div", [
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("mark-as-complete-text"))
                    }
                  })
                ])
              : _c(
                  "div",
                  [
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("history-files-overwrite-content")
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("b-form-file", {
                      staticClass: "col-lg-7 col-12 mt-2 mb-4",
                      attrs: {
                        placeholder: _vm.$t("select-or-drag-drop-file"),
                        "drop-placeholder": _vm.$t("drag-drop-file"),
                        "browse-text": _vm.$t("browse")
                      },
                      model: {
                        value: _vm.uploaderOverwrite.file,
                        callback: function($$v) {
                          _vm.$set(_vm.uploaderOverwrite, "file", $$v)
                        },
                        expression: "uploaderOverwrite.file"
                      }
                    }),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("history-files-overwrite-question")
                        )
                      }
                    })
                  ],
                  1
                ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "base-button",
                  { staticClass: "mr-2", on: { click: _vm.completeFile } },
                  [_vm._v(_vm._s(_vm.$t("yes")))]
                ),
                _vm._v(" "),
                _c(
                  "base-button",
                  { attrs: { red: "" }, on: { click: _vm.resetCompleteModal } },
                  [_vm._v(_vm._s(_vm.$t("no")))]
                )
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("base-dialog", {
        attrs: {
          content: _vm.lockDialogInfo.locking
            ? _vm.$t("lock-file-advice")
            : _vm.$t("unlock-file-advice"),
          okFn: function() {
            _vm.lockDialogInfo.locking ? _vm.lockFile() : _vm.unlockFile()
          },
          cancelFn: function() {
            _vm.lockDialogInfo.show = false
          }
        },
        model: {
          value: _vm.lockDialogInfo.show,
          callback: function($$v) {
            _vm.$set(_vm.lockDialogInfo, "show", $$v)
          },
          expression: "lockDialogInfo.show"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a83df30", esExports)
  }
}

/***/ }),

/***/ 3437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_HistoryFilesSection_vue__ = __webpack_require__(2712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_clinicHistory_mixin__ = __webpack_require__(2446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_buttons_BaseButton_vue__ = __webpack_require__(124);
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        HistoryFilesSection: __WEBPACK_IMPORTED_MODULE_0__components_shared_HistoryFilesSection_vue__["a" /* default */],
        BaseButton: __WEBPACK_IMPORTED_MODULE_3__base_buttons_BaseButton_vue__["default"]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_clinicHistory_mixin__["a" /* default */]],
    data: function data() {
        return {
            MENU_PATH: __WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__["O" /* MENU_PATH */],
            DOCUMENTS_HISTORY_PATH: __WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__["n" /* DOCUMENTS_HISTORY_PATH */]
        };
    }
});

/***/ }),

/***/ 3975:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3976);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("4db51c9e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f60cbc42\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClinicHistoryFiles.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f60cbc42\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClinicHistoryFiles.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3976:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ 3977:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "mb-5" }, [_c("history-files-section")], 1)
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f60cbc42", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/68.d5b981dff7718c50626d.js